import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';

import { DOCUMENT } from '@angular/common';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import * as _ from 'lodash';
import { concatMap, finalize, switchMap } from 'rxjs/operators';
import { TildaProjectsDialogComponent } from 'src/app/shared/dialogs/tilda-projects-dialog/tilda-projects-dialog.component';
import { SubTypeEnum, WebMenuEnum } from 'src/app/shared/enums/enums';
import {
  CustomTabIconDataInterface,
  TabInterface,
  TabViewOnInterface
} from 'src/app/shared/interfaces/tab-interface';
import { Addon, FeedOptions, PublicProperties } from 'src/app/shared/models/addon.model';
import { AuthService, AuthType } from 'src/app/shared/services/auth.service';
import { TildaService } from 'src/app/shared/services/tilda.service';
import { SharedService } from 'src/app/shared/shared.service';
import { NoWhitespaceValidator } from 'src/app/shared/validators/no-whitespace-validator';
import { ValidateWeblink } from 'src/app/shared/validators/weblink-validator';
import { SubSink } from 'subsink';
import { GroupsService } from '../../../groups/groups.service';
import { GroupDetail } from '../../../groups/models/group-detail.model';
import { ExdrLanguageService } from '../../../languages/services/exdr-language.service';
import { LoadingService } from '../../../shared/components/loading/loading.service';
import { TopicSearchDialogComponent } from '../../../shared/dialogs/topic-search-dialog/topic-search-dialog.component';
import { TabKeyEnum } from '../../../shared/enums/tab-key-enum';
import { FileItem } from '../../../shared/models/file-item';
import { FileService } from '../../../shared/services/file.service';
import { ConnectAppsService } from '../../group-settings/group-settings-panel/connected-apps/services/connect-apps.service';
import { CustomTabValueDialogComponent } from '../custom-tab-value-dialog/custom-tab-value-dialog.component';
import { AccessListDialogComponent } from './access-list-dialog/access-list-dialog.component';
import { TopictypeSearchDialogComponent } from './topictype-search-dialog/topictype-search-dialog.component';
import { TabVisibiltyComponent } from './tab-visibilty.component.ts/tab-visibilty.component';
import { AlertService } from 'src/app/shared/alert/alert.service';
import { TopicTypeService } from 'src/app/products/products-type-setting/topic-type.service';
import { ProductDataSource } from 'src/app/products/product-data-source';
import { ProductsService } from 'src/app/products/products.service';
import { SlideBg } from 'src/app/products/models/slide.model';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { TabUtilityType } from 'src/app/shared/enums/custom-tab';

export type actionType = 'create' | 'update'

export interface NewCustomTabInterface {
  icon?: number;
  title?: string;
  subtype: number;
  viewOn;
  utilityType?: string;
  visibleBy?;
  hiddenFrom?;
  refTab?: string;
  groupSettingsAddonData?: any;
  url?: string;
  productId?: string;
  productName?: string;
  metaTitle?: string;
  metaDescription?: string;
  feedStream?: string;
  feedStreamDesign?: StreamDesignType;
  feedStreamLinkDesign?: DesignType;
  slug?: string;
  dividers?: string;
  urlName?: string;
  tabLayout?: string;
  tabDescription?: string;
  backgroundColor?: string,
  isHighlightTab?: boolean,
  subTabs?;
  allowFeedOptions?: FeedOptions;
  bannerData?: {
    heading?: string,
    subHeading?: string,
    backgroundImage?: string,
    action: {
      label?: string,
      link?: string
    }
  }
}

export enum TabTypeEnum {
  CustomTab,
  Tab
}

export enum EspDividerEnum {
  Actions = "Actions",
  Mine = "Mine",
  All = "All",
  Catalog = "Catalog"
}

export enum ActivitiesDividerEnum {
  Mine = "Mine",
  Following = "Following",
  Backlog = "Backlog",
  Boards = "Boards",
  All = "All"
}

export enum ScoreCardDividerEnum {
  Mine = "Mine",
  Cards = "Cards",
  Teams = "Teams",
  Members = "Members"
}

export enum BannerImageEnum {
  None = "None",
  White = "White",
  Select_Image = "Select Image"
}
export interface TabFormValueInterface {
  icon: number
  subtype: SubTypeEnum
  title: string
  viewOn: string
  productId?: string | number
  productName?: string
}

export enum StreamDesignType {
  Media = "media",
  Blog = "blog",
  Feed = "feed",
  Links = 'links'
}

export enum DesignType {
  Cards = "cards",
  List = "list"
}

@Component({
  selector: 'xcdrs-tab-form',
  templateUrl: './tab-form.component.html',
  styleUrls: ['./tab-form.component.scss']
})

export class TabFormComponent implements OnInit, OnDestroy {

  slideBgColors = SlideBg.slideBgColors();
  topicdDataSource: ProductDataSource;
  bannerCtrl = new UntypedFormControl(false);
  espDividers = new UntypedFormControl('');
  activitiesDivders = new UntypedFormControl('');
  scorecardDivders = new UntypedFormControl('');
  highlightTab = new FormControl(false);
  customColor = new FormControl('', [this.hexColorValidator()]);

  simplestrataAddon: Addon;
  form: UntypedFormGroup;
  subtype = SubTypeEnum;
  bannerImageType = BannerImageEnum;
  espDividerEnum = EspDividerEnum;
  espDividerEnumValues = Object.values(EspDividerEnum);
  activitiesDividerEnumValues = Object.values(ActivitiesDividerEnum)
  scoreCardDividerEnumValues = Object.values(ScoreCardDividerEnum)
  tabType: TabTypeEnum;
  group: GroupDetail;
  espAddon: Addon;
  virtualRoomAddon: Addon;
  tildaAddon: Addon;
  technadoptAddon: Addon;
  tabOrderAddon: Addon;
  selectedDesignPageData: {
    id: string,
    name: string,
    url?: string
  };
  subtypeAddons: {
    isTechnadoptAddon: boolean,
    isEspAddon: boolean,
    isDashboardsAddon: boolean,
    isTildaAddon: boolean
  }
  allowFeedOptions: FeedOptions = { likes: true, comments: true, announcer: true };

  selectedSubtype: SubTypeEnum;
  tabKeyEnum = TabKeyEnum;
  webMenuEnum = WebMenuEnum;
  streamDesignType = StreamDesignType;
  designType = DesignType;
  addon: Addon;
  tabtypehome?: 'home';
  utilityType?: 'text' | 'icon' | 'footer' | 'footerUtilities' | 'socialFooterUtility' | 'floatingTab' | '';
  selectedBIType: BannerImageEnum = BannerImageEnum.White;
  selectedStreamDesign: StreamDesignType = StreamDesignType.Feed;
  selectedDesign: DesignType = DesignType.Cards;
  selectedImage: any;
  typingTimer: any;
  minDate = new Date();
  TabUtilityType = TabUtilityType;

  allTabs: Array<TabInterface> = [];
  footerTabs: Array<TabInterface> = [];
  icons: CustomTabIconDataInterface[] = [];
  viewOnData: TabViewOnInterface[] = [];
  subGroups: GroupDetail[] = [];
  groupSettingsAddonData: any[] = [];
  addons: Addon[] = [];
  customType: any[] = [];
  groupsVisibility: any[] = [];
  hiddenFromGroups: any[] = [];

  isBannerActive: boolean = false;
  viewOnChanges: boolean = false;
  disableStreamDesignSelection: boolean = false;
  disableDesignSelection: boolean = false;
  isCreatingGroup: boolean = false;
  enableMetaData: boolean = true;
  urlNamePrefilled: boolean = false;
  hasSubtype5: boolean;
  isNested: boolean = false;
  isCustomColor: boolean = false;
  isArabic: boolean = false;
  forceMobileView: boolean = false;
  floatingTabLimitReached: boolean = false;

  selectedTabIcon: number = 1;
  metaDescriptionMaxLength = 200;
  typingTimeout = 1000;

  selectedTabForFooter: string = '';
  selectedItemIds: string = '';
  selectedItemNames: string = '';
  feedStream: string = '';
  selectedDesignPage: string = '';
  placeholder: string;
  metaTitle: string;
  metaDescription: string;
  bannerImage: string;
  slug: string;
  tabLayout: string;
  orignalLayout: string;
  tabDescription: string;
  orgId: string;
  activeSlideBg: string;

  public PublicProperties: any[] = [];
  public selectedValues: any[] = [];

  private subs: SubSink = new SubSink();

  @Input() action: actionType = 'create'
  @Input() tab: TabInterface
  @Input() customTab: Addon
  @Input() disabledBtn: boolean
  @Input() isHomePage: boolean = false;

  @Output() emitSubtypeSelect: EventEmitter<SubTypeEnum> = new EventEmitter<SubTypeEnum>()
  @Output() emitNewTab: EventEmitter<NewCustomTabInterface> = new EventEmitter<NewCustomTabInterface>()
  @Output() emitFormValue: EventEmitter<{ tab?: TabInterface, customTab?: Addon, addon?: any, groupLanguages?: any[] }>
    = new EventEmitter<{ tab?: TabInterface, customTab?: Addon }>()

  @ViewChild('visibleByComponent') visibleByComponent: TabVisibiltyComponent;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkContainerWidth();
  }

  constructor(
    private sharedService: SharedService,
    private fileService: FileService,
    private elRef: ElementRef,
    private authService: AuthService,
    private groupsService: GroupsService,
    private connectAppService: ConnectAppsService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private langService: ExdrLanguageService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private productsService: ProductsService,
    private tildaService: TildaService,
    private router: Router,
    private topicTypeService: TopicTypeService,
    @Inject(DOCUMENT) private document: Document,
    private translateService: TranslateService
  ) {
    this.uniqueUrlNameValidator = this.uniqueUrlNameValidator.bind(this);
  }

  ngOnInit(): void {
    this.checkContainerWidth();
    this.getLanguage();
    this.topicdDataSource = new ProductDataSource(this.productsService);
    this.utilityType = this.route.snapshot.queryParams.utilityType;
    this.tabtypehome = this.route.snapshot.queryParams.tabType;
    console.log("this.tabtypehome...........", this.tabtypehome)
    this.isHomePage = this.customTab ? this.customTab.PublicProperties?.isLandingPageTab == true : this.isHomePage;
    this.initValues();
    this.isCreatingGroup = this.sharedService.isCreatingGroup;
    this.initTabsList();
    if (this.action == 'update') {
      // Finding and setting bool for whether allowed to change from navigation to innertab
      this.checkWeblinks();
      // Check if the `nested` parameter is present and set its value
      this.isNested = this.route.snapshot.queryParams['nested'] === 'true';
    }
    this.subs.sink = this.bannerCtrl.valueChanges.subscribe(val => {
      this.isBannerActive = val;
    });
    if (this.tab?.isHighlightTab || this.customTab?.PublicProperties?.isHighlightTab) {
      this.highlightTab.setValue(this.tab?.isHighlightTab || this.customTab?.PublicProperties?.isHighlightTab);
    }
    if (this.tab?.backgroundColor || this.customTab?.PublicProperties?.backgroundColor) {
      this.activeSlideBg = this.tab?.backgroundColor || this.customTab?.PublicProperties?.backgroundColor || '';
      this.isCustomColor = SlideBg.isHexCodeNotInColors(this.activeSlideBg);
      if (this.isCustomColor) {
        this.customColor.setValue(this.activeSlideBg);
      }
      this.cdr.detectChanges();
    }
  }

  sendTitle(): void {
    return this.form.get("subtype")?.value;
  }

  getLanguage() {
    let lang: any = localStorage.getItem("preferredLanguage")
      ? JSON.parse(localStorage.getItem("preferredLanguage"))
      : "";
    if (lang) this.isArabic = lang.locale == "ar" || false;
  }

  checkWeblinks() {

    // Step 1: Find the current tab in allTabs using customTabId
    const currentKey = this.customTab?.PublicProperties?.customTabId;
    const foundTab = this.allTabs.find(tab => tab.key === `custom tab${currentKey}`);
    if (foundTab) {
      // Step 2: Get the IDs of subtabs from the found tab
      const subTabIds = foundTab.data.subTabs; // Assuming these are just IDs
      // Step 3 & 4: Check each subTab ID in allTabs to see if any have a subtype of 5
      this.hasSubtype5 = subTabIds.some(subTabId => {
        const subTab = this.allTabs.find(tab => tab.key === subTabId);
        return subTab && subTab.data?.subtype === 5;
      });
    } else {
      this.hasSubtype5 = false;
    }
  }


  initValues(): void {
    this.customType = [];

    this.tabType = this.customTab ? TabTypeEnum.CustomTab : TabTypeEnum.Tab
    this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(map(addons => {
      this.addons = addons;
      this.tabOrderAddon = addons.find(a => a.Type == AuthType.TabOrder)
      this.groupSettingsAddonData = this.getSelectedTabLanguagesFromAddon(addons);
      console.log("this.groupSettingsAddonData...........", this.groupSettingsAddonData)
      const appApperance = addons.find(a => a.Type == AuthType.AppAppearance)
      if (this.tab?.key == TabKeyEnum.Profile) {
        this.initWebMenu(appApperance);
      }
      this.customType = addons.filter(a => a.Type.toLowerCase() == AuthType.CustomTab.toLowerCase() && a.PublicProperties.feedStream);
      if (this.customType) {
        this.customFeedStream(this.customType);
      }
      this.virtualRoomAddon = addons?.find(a => a?.Type?.toLowerCase() == AuthType.VirtualRoom.toLowerCase());
      this.espAddon = addons.find(a => a.Type.toLowerCase() == AuthType.ESP.toLowerCase());
      this.tildaAddon = addons.find(a => a.Type.toLowerCase() == AuthType.Tilda.toLowerCase());
      this.technadoptAddon = addons.find(a => a.Type.toLowerCase() == AuthType.Technadopt.toLowerCase());
      this.simplestrataAddon = addons.find(a => a.Type.toLowerCase() == AuthType.SimpleStrata.toLowerCase())
      return {
        isTechnadoptAddon: !!this.technadoptAddon,
        isEspAddon: !!this.espAddon,
        isDashboardsAddon: !!addons.find(addon => addon.Type === AuthType.PowerBi),
        isTildaAddon: !!this.tildaAddon,
      }
    })).subscribe(res => {
      this.subtypeAddons = res;
      this.initIcons()
      this.initTabVisibility(this.tabType)
      this.initForm();
      this._loadSubGroups();
    });
  }

  onHightlightToggleChange(event: MatSlideToggleChange): void {
    this.highlightTab.setValue(event.checked)
  }

  initWebMenu(appApperance: Addon) {
    if (!this.tab.webMenu) {
      this.tab.webMenu = appApperance?.PublicProperties?.directURLNavigationMenu ?? WebMenuEnum.SIGN_IN_UP;
    }
  }

  shouldShow(): boolean {
    if (this.utilityType == 'footer' || this.utilityType == TabUtilityType.FooterUtilities || this.utilityType == TabUtilityType.SocialFooterUtility || this.utilityType == 'icon') {
      return false;
    } else if (this.tab) {
      if (this.tab.key == TabKeyEnum.EspAttendance) {
        return false;
      }
    }

    return true;
  }

  customFeedStream(customType) {
    for (let i = 0; i < customType.length; i++) {
      if (customType[i].PublicProperties.feedStream.toLowerCase() === 'blog') {
        customType[i].PublicProperties.feedStream = customType[i].PublicProperties.feedStream.toLowerCase();
      }
    }
    let exist = customType.some(custom => custom.PublicProperties.feedStream.toLowerCase() === 'blog')
    if (!exist) {
      this.customType.unshift({
        Type: "custom tab",
        Configuration: {
          baseURL: "",
          access_token: "",
          refresh_token: ""
        },
        PublicProperties: {
          bannerData: {
            heading: "",
            subHeading: "",
            active: "",
            backgroundImage: "",
            action: { label: "", link: "" }
          },
          feedStream: "blog",
          groupIdenedi: "",
          icon: 1,
          isLandingPageTab: false,
          jsonData: "{\n\n}",
          metaDescription: "",
          metaTitle: "",
          name: "",
          slug: "",
          subtype: 9,
          title: "",
          viewOn: "",
          visibleBy: [{ "": "" }],
        },
        UserIdenedi: "",
        InstanceId: "",
        EntityType: ""
      });
    }
    customType = _.uniqBy(customType, obj => obj.PublicProperties.feedStream.toLowerCase());
    customType.forEach(data => {
      return this.PublicProperties.push(data.PublicProperties);
    });
  }

  translationsMissing() {
    if (this.groupSettingsAddonData?.length && this.form.value.subtype != SubTypeEnum.NAVIGATION_TAB) {
      return this.groupSettingsAddonData.some(l => l?.isEnable == '1' && (!l?.name || l?.name == ''))
    }
    return false;
  }

  setNameForEnLan() {
    if (this.groupSettingsAddonData) {
      this.groupSettingsAddonData?.map(l => {
        if (l?.langKey == 'en') {
          l.name = this.form.get('title')?.value;
        }
        return l;
      })
    }
  }

  canDisableTab(langKey: string) {
    if (this.groupSettingsAddonData) {
      return !(this.groupSettingsAddonData.some(ad => ad?.isEnable == '1' && ad.langKey !== langKey))
    }
    return true;
  }

  isCustomTab() {
    if (this.customTab) {
      return true
    } else
      return false
  }

  onChangeStartDate(startDate) {
    if (startDate) {
      if (new Date(this.form.value.endDate) < new Date(startDate)) {
        this.form.get('endDate').setValue(null);
      }
    }
  }

  getSelectedTabLanguagesFromAddon(addons): any[] {
    const groupSettingsAddonDataObj = addons.find(addon => addon.Type === AuthType.GroupLanguages)?.PublicProperties?.jsonData;

    console.log("groupSettingsAddonDataObj...........", groupSettingsAddonDataObj)
    const groupSettingsAddonData = [];
    if (groupSettingsAddonDataObj) {
      for (const [key, value] of Object.entries(groupSettingsAddonDataObj)) {
        if (value['settings']?.isEnable == '1') {
          const tabKey = this.customTab?.PublicProperties?.customTabId || this.tab?.key;
          if (tabKey) {
            const tabData = value[tabKey];
            groupSettingsAddonData.push({
              tabKey,
              langKey: key,
              url: tabData?.url ?? '',
              urlType: tabData?.url || tabData?.topic?.id || tabData?.library?.id ? 'differentUrl' : 'baseUrl',
              topic: tabData?.topic ?? { id: '', name: '', slug: '' },
              library: tabData?.library ?? { id: '', name: '', slug: '' },
              isEnable: tabData?.isEnable ?? "1",
              name: tabData?.name || this.customTab?.PublicProperties?.name || this.tab?.name || '',
            })
          } else {
            groupSettingsAddonData.push({
              tabKey: '',
              langKey: key,
              url: '',
              urlType: 'baseUrl',
              topic: { id: '', name: '', slug: '' },
              library: { id: '', name: '', slug: '' },
              isEnable: "1",
              name: '',
            })
          }

        }
      }
    }
    return groupSettingsAddonData;
  }

  private checkContainerWidth() {
    const isCreateGroupRoute = this.router.url.includes('/create-group');
    const containerWidth = this.elRef.nativeElement.offsetWidth;

    if (isCreateGroupRoute) {
      this.forceMobileView = containerWidth < 768;

      if (this.forceMobileView) {
        // Apply the specific margin and update button position as required
        this.elRef.nativeElement.style.marginTop = '-3.75rem';
        // Additional code to adjust the update button, if needed
      }
    } else {
      this.forceMobileView = false;
    }
  }

  initForm(): void {

    this.bannerImage = this.customTab?.PublicProperties?.bannerData?.backgroundImage || this.tab?.bannerData?.backgroundImage || '';
    this.setSelectedBIType();
    this.setSelectedDesignPage();

    const startDate = this.customTab?.PublicProperties?.bannerData?.startDate || this.tab?.bannerData?.startDate || '';
    this.allowFeedOptions = this.customTab?.PublicProperties?.allowFeedOptions || this.tab?.allowFeedOptions || { likes: true, comments: true, announcer: true };

    this.form = new UntypedFormGroup({
      title: new UntypedFormControl(this.isHomePage ? 'Home' : (this.customTab?.PublicProperties?.name || this.tab?.name),
        [Validators.required, Validators.maxLength(this.tab?.key == TabKeyEnum.EspAttendance ? 20 : 12), NoWhitespaceValidator]),
      icon: new UntypedFormControl(this.selectedTabIcon || '', Validators.required),
      metaTitle: new UntypedFormControl(this.customTab?.PublicProperties?.metaTitle || this.tab?.metaTitle || ''),
      metaDescription: new UntypedFormControl(this.customTab?.PublicProperties?.metaDescription || this.tab?.metaDescription || ''),
      bannerHeading: new UntypedFormControl(this.customTab?.PublicProperties?.bannerData?.heading || this.tab?.bannerData?.heading || ''),
      bannerSubHeading: new UntypedFormControl(this.customTab?.PublicProperties?.bannerData?.subHeading || this.tab?.bannerData?.subHeading || ''),
      bannerButtonLabel: new UntypedFormControl(this.customTab?.PublicProperties?.bannerData?.action?.label || this.tab?.bannerData?.action?.label || ''),
      bannerButtonLink: new UntypedFormControl(this.customTab?.PublicProperties?.bannerData?.action?.link || this.tab?.bannerData?.action?.link || '', [RxwebValidators.url()]),
      footerTabCtrl: new UntypedFormControl(''),
      backgroundColor: new UntypedFormControl(this.customTab?.PublicProperties?.backgroundColor || this.tab?.backgroundColor || ''),
      startDate: new UntypedFormControl(startDate),
      endDate: new UntypedFormControl(this.customTab?.PublicProperties?.bannerData?.endDate || this.tab?.bannerData?.endDate || ''),
      allowFeedOptions: new UntypedFormControl(this.allowFeedOptions)
    });


    if (startDate && new Date(startDate) < new Date()) {
      this.minDate = new Date(startDate);
    }

    this.form.valueChanges.pipe()
      .subscribe(() => {
        if (this.form.controls['title'].value?.trim() == ""
          // && this.form.controls['icon'].value?.trim() == ""
          && this.form.controls['metaTitle'].value?.trim() == ""
          && this.form.controls['metaDescription'].value?.trim() == ""
          && this.form.controls['bannerHeading'].value?.trim() == ""
          && this.form.controls['bannerSubHeading'].value?.trim() == ""
          && this.form.controls['bannerButtonLabel'].value?.trim() == ""
          && this.form.controls['bannerButtonLink'].value?.trim() == "") {
          this.form.controls['bannerButtonLabel'].setValidators([])
          this.form.controls['bannerButtonLink'].setValidators([])
        }
        else {
          this.form.controls['bannerButtonLabel'].setValidators(this.form.value.bannerButtonLabel || this.form.value.bannerButtonLink ? [Validators.maxLength(100), Validators.required] : []);
          this.form.controls['bannerButtonLink'].setValidators(this.form.value.bannerButtonLink || this.form.value.bannerButtonLabel ? [Validators.required, RxwebValidators.url()] : []);
          this.form.controls['bannerButtonLabel'].markAsTouched();
          this.form.controls['bannerButtonLink'].markAsTouched();
        }
        for (let key in this.form.controls) {
          this.form.controls[key].updateValueAndValidity({ emitEvent: false });
        }

        this.setNameForEnLan();

      });


    if (this.action == 'update' && this.tabType === TabTypeEnum.CustomTab) {
      this.selectedSubtype = this.customTab.PublicProperties.subtype;
      this.form.addControl('subtype', new UntypedFormControl({
        value: this.selectedSubtype,
        disabled: this.action === 'update' && !this.customTab?.PublicProperties?.isLandingPageTab == true
      }, Validators.required));
    }

    this.isBannerActive = this.customTab?.PublicProperties?.bannerData?.active == '1' || this.tab?.bannerData?.active == '1';
    this.bannerCtrl.setValue(this.isBannerActive, { emitEvent: false });

    this.highlightTab.setValue(this.customTab?.PublicProperties?.isHighlightTab || this.tab?.isHighlightTab)

    if (this.tab?.dividers == undefined && this.tab?.key == TabKeyEnum.Requests) {
      this.espDividers.setValue(this.espDividerEnumValues);
    } else {
      this.espDividers.setValue(this.tab?.dividers ? this.tab?.dividers?.split(',') : '');
    }


    //Initializing the values for default tabs dividers
    if (this.customTab?.PublicProperties?.subtype == SubTypeEnum.REQUESTS) {
      if (this.customTab?.PublicProperties?.dividers == undefined) {
        this.espDividers.setValue(this.espDividerEnumValues);
      } else {
        this.espDividers.setValue(this.customTab?.PublicProperties?.dividers ? this.customTab.PublicProperties?.dividers?.split(',') : '');
      }
    }

    if (this.customTab?.PublicProperties.subtype == SubTypeEnum.ACTIVITIES) {
      if (this.customTab?.PublicProperties?.dividers == undefined) {
        this.activitiesDivders.setValue(this.activitiesDividerEnumValues);
      } else {
        this.activitiesDivders.setValue(this.customTab?.PublicProperties?.dividers ? this.customTab.PublicProperties?.dividers?.split(',') : '');
      }
    }

    if (this.customTab?.PublicProperties.subtype == SubTypeEnum.SCORE_CARD) {
      if (this.customTab?.PublicProperties?.dividers == undefined) {
        this.scorecardDivders.setValue(this.scoreCardDividerEnumValues);
      } else {
        this.scorecardDivders.setValue(this.customTab?.PublicProperties?.dividers ? this.customTab.PublicProperties?.dividers?.split(',') : '');
      }
    }

    console.log("THE TAB...", this.tab)

    if (this.tab?.key == TabKeyEnum.ScoreCard) {
      if (this.tab?.dividers == undefined) {
        this.scorecardDivders.setValue(this.scoreCardDividerEnumValues);
      } else {
        this.scorecardDivders.setValue(this.tab?.dividers ? this.tab?.dividers?.split(',') : '');
      }
    }

    if (this.tab?.key == TabKeyEnum.Activities) {
      if (this.tab?.dividers == undefined) {
        this.activitiesDivders.setValue(this.activitiesDividerEnumValues);
      } else {
        this.activitiesDivders.setValue(this.tab?.dividers ? this.tab?.dividers?.split(',') : '');
      }
    }

    if (this.tab?.key == TabKeyEnum.SocialMedia) {
      this.placeholder = 'CustomTabsPage.SelectGroup';
    }
    if (this.action === 'create' || this.tabType === TabTypeEnum.CustomTab) {
      // Ask about this
      if (this.tabType === TabTypeEnum.CustomTab) {
        this.selectedSubtype = this.customTab?.PublicProperties?.subtype || this.tab?.subtype || SubTypeEnum.TOPIC;
      } else {
        this.selectedSubtype = this.customTab?.PublicProperties?.subtype || this.tab?.subtype || SubTypeEnum.TOPIC || SubTypeEnum.FEEDS || SubTypeEnum.LIBRARY;
      }
      if (this.action === 'create' && this.utilityType == 'footer') {
        this.selectedSubtype = SubTypeEnum.NAVIGATION_TAB;
      }

      this.isMetaDataEnable();
      this.form.addControl('subtype', new UntypedFormControl({
        value: this.selectedSubtype,
        disabled: this.action === 'update' && !this.customTab?.PublicProperties?.isLandingPageTab == true
      }, Validators.required));

      this.handleUrlCtrl(this.customTab?.PublicProperties?.subtype, this.customTab?.PublicProperties)
      this.ctUrlNameCtrl(this.customTab?.PublicProperties)
      this.selectedItemIds = this.customTab?.PublicProperties?.productId?.toString() ?? '';
      this.selectedItemNames = this.customTab?.PublicProperties?.productName?.toString() ?? '';
      this.slug = this.customTab?.PublicProperties?.slug?.toString() ?? '';
      this.selectedValues = [];
      this.feedStream = this.customTab?.PublicProperties?.feedStream?.toString() ?? '';
      this.selectedStreamDesign = this.selectedSubtype == SubTypeEnum.FEEDS ?
        this.customTab?.PublicProperties?.feedStreamDesign || StreamDesignType.Feed : null;

      this.selectedDesign = this.selectedStreamDesign == StreamDesignType.Links ?
        this.customTab?.PublicProperties?.feedStreamLinkDesign || DesignType.Cards : null;
      if (this.customTab !== undefined) {
        this.selectedValues.push(this.customTab.PublicProperties);
      }
      if (this.selectedSubtype == SubTypeEnum.RequestCatalog || this.selectedSubtype == SubTypeEnum.REQUESTS) {
        this.allowRequestSelection = !!this.selectedItemIds?.length;
      }

      this.setValuePlaceholder(this.selectedSubtype);
    }
    if (this.action == 'update' && this.selectedSubtype == SubTypeEnum.TILDA) {
      this.selectedDesignPageData = {
        id: this.customTab?.PublicProperties?.productId?.toString() ?? '',
        name: this.customTab?.PublicProperties?.productName?.toString() ?? '',
        url: this.customTab?.PublicProperties?.iFrameURL
      }
    }

    if (this.action == 'update' && this.selectedSubtype == SubTypeEnum.NAV_GROUP) {
      this.tabLayout = this.customTab?.PublicProperties?.tabLayout ?? 'navigation';
      this.orignalLayout = this.tabLayout;
      this.tabDescription = this.customTab?.PublicProperties?.tabDescription ?? '';
    }

    if (this.action === 'update' && this.selectedSubtype == SubTypeEnum.LIBRARY) {
      this.selectedItemIds = this.customTab?.PublicProperties?.productId.toString() ?? '';
      this.fetchTopicTypeName(this.selectedItemIds).subscribe(name => {
        this.selectedItemNames = name;
        this.cdr.detectChanges();
      });
    }

    if (this.action == 'update' && ([TabKeyEnum.Requests, TabKeyEnum.EspRecords, TabKeyEnum.EspSurveys].includes(this.tab?.key as TabKeyEnum) || this.selectedSubtype == SubTypeEnum.REQUESTS)) {
      if (this.tabType === TabTypeEnum.Tab) {
        this.selectedItemIds = this.tab?.productId?.toString() ?? '';
        this.selectedItemNames = this.tab?.productName?.toString() ?? '';
      }
      this.allowRequestSelection = !!this.selectedItemIds?.length;
      this.placeholder = 'CustomTabsPage.SelectRequests';
    }
  }

  onTitleFocusOut(event: any) {
    const filterSubTypes = [SubTypeEnum.WEB_LINK, SubTypeEnum.NAVIGATION_TAB]
    if (!this.tab && !filterSubTypes.includes(this.selectedSubtype) && this.customTab?.PublicProperties?.isDefaultTab != 1
      && !this.isHomePage) {
      this.setUpUrlName();
    }
  }

  clearDate(controlName: string) {
    this.form.get(controlName).setValue(null);
  }

  hexColorValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || control.value === '#') {
        // If the field is empty or only contains the hash, consider it valid.
        return null;
      }
      const validHexColor = /^#[0-9a-fA-F]{6}$|^#[0-9a-fA-F]{8}$/;
      if (validHexColor.test(control.value)) {
        return null;
      } else {
        return { invalidHex: this.isArabic ? 'رمز اللون غير صالح' : 'The color code is not valid.' };
      }
    };
  }


  validateInput(event: KeyboardEvent): void {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'a', 'b', 'c', 'd', 'e', 'f', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    const isCtrlOrCmd = event.ctrlKey || event.metaKey;
    if (isCtrlOrCmd && (event.key === 'v' || event.key === 'V' || event.key === 'c' || event.key === 'C')) {
      return;
    }
    if (!allowedKeys.includes(event.key) && !event.key.startsWith('Arrow')) {
      event.preventDefault();
    }
  }

  onFocus() {
    if (this.customColor.value === '') {
      this.customColor.setValue('#');
    }
  }

  onBlur() {
    if (this.customColor.value === '#') {
      this.customColor.setValue('');
    }
  }

  filterHash(value: string, event: Event) {
    // Replace all occurrences of # except the first one and convert to uppercase
    const cleanedValue = value.replace(/^(#*)(.*)$/, '#$2').replace(/#/g, '');
    const newValue = `#${cleanedValue.toUpperCase()}`;
    // Update the control's value only if it's different to prevent cursor jump
    if (newValue !== this.customColor.value) {
      this.customColor.setValue(newValue);
      event.preventDefault();  // Prevent the default to stop the cursor from jumping
    }
  }

  setUpUrlName(event?: any) {
    const titleVal = this.form.controls['title']?.value;
    const urlNameCtrl = this.form.controls['urlName'];

    if (titleVal && (!urlNameCtrl?.value || (!urlNameCtrl.touched && !this.customTab?.PublicProperties?.urlName))) {
      this.setUrlNameFromTitle();
    }
  }

  uniqueUrlNameValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!this.addons?.length) { return null; }
    const existed = this.addons.filter(a => a.Type == "custom tab" && this.customTab?.InstanceId !== a.InstanceId).map(ad => {
      return ad.PublicProperties?.urlName;
    })?.includes(control.value);

    if (existed) {
      return { 'notUnique': true }
    }

    return null
  }

  setUrlNameFromTitle() {
    const slugs = this.addons.filter(a => a.Type == "custom tab" && !!a.PublicProperties?.urlName).map(ad => {
      return ad.PublicProperties?.urlName;
    })
    let slug = this.generateUniqueSlug(slugs, this.form.controls['title']?.value?.toLowerCase());
    this.form.controls['urlName'].setValue(slug);
    this.form.controls['urlName'].updateValueAndValidity()
  }

  generateUniqueSlug(existingSlugs, text) {
    const baseSlug = text.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    let newSlug = baseSlug;
    let count = 1;

    while (existingSlugs.includes(newSlug)) {
      newSlug = `${baseSlug}-${count}`;
      count++;
    }

    return newSlug;
  }

  setValuePlaceholder(subtype: SubTypeEnum) {
    if (subtype == SubTypeEnum.TOPIC) {
      this.placeholder = 'CustomTabsPage.SelectTopic';
    }
    // NewCusTab 2: Add a placeholder for Library
    if (subtype == SubTypeEnum.LIBRARY) {
      this.placeholder = 'CustomTabsPage.SelectTopicType';
    }
    if (subtype == SubTypeEnum.FEEDS) {
      this.placeholder = 'CustomTabsPage.Stream';
    }
    else if (subtype == SubTypeEnum.REQUEST || subtype == SubTypeEnum.REQUESTS) {
      this.placeholder = 'CustomTabsPage.SelectRequest';
    }
    else if (subtype == SubTypeEnum.RequestCatalog) {
      this.placeholder = 'CustomTabsPage.SelectRequests';
    }
    else if (subtype == SubTypeEnum.DASHBOARD) {
      this.placeholder = 'CustomTabsPage.SelectDashboard';
    }
    else if (subtype == SubTypeEnum.TILDA) {
      this.placeholder = 'CustomTabsPage.SelectPage'
    }

  }
  initIcons(): void {
    this.icons = this.sharedService.getCustomTabIcons()
    if (this.tabType === TabTypeEnum.Tab && this.action === 'update') {
      const defaultIcon = this.sharedService.getHeaderTabs({
        key: this.tab.key
      });
      this.icons.unshift({
        id: 1,
        path: defaultIcon[0].iconPath
      })
      this.selectedTabIcon = this.tab.icon
      this.icons = this.icons.map((icon, idx) => {
        icon.id = idx + 1
        return icon
      })
      if (this.tab.icon === 0 || !this.tab.icon) {
        this.selectedTabIcon = 1
      }
    }
    if ((this.tabType === TabTypeEnum.CustomTab && this.action === 'update')) {
      this.selectedTabIcon = this.customTab.PublicProperties.icon
    }
    this.viewOnData = this.sharedService.getViewOnData();
    if (this.utilityType?.startsWith('footer') || this.utilityType?.startsWith(TabUtilityType.FloatingTab)) {
      this.viewOnData = this.viewOnData.filter(v => v?.name == 'Web')
    }

  }

  initTabVisibility(tabType: TabTypeEnum) {
    if (tabType === TabTypeEnum.CustomTab) {
      this.viewOnData = this.viewOnData.map(el => {
        if (this.customTab.PublicProperties.viewOn.includes(el.name)) {
          el.active = true
          return el
        } else {
          return el
        }
      })
    }
    if (tabType === TabTypeEnum.Tab && this.action === 'update') {
      this.viewOnData = this.viewOnData.map(el => {
        // if (this.tab?.viewOn) {

        if (this.tab.viewOn?.length > 0) {
          el.active = this.tab?.viewOn.includes(el.name)
          return el
        } else if (this.tab?.viewOn?.length === 0) {
          el.active = false;
          return el
        } else {
          el.active = true
          return el
        }
        return el

      })
    }
  }

  onUrlTypeChanged(urlType: string, groupLanguage) {
    if (urlType === 'baseUrl') {
      groupLanguage.url = groupLanguage.topic = groupLanguage.library = undefined;
    }
  }

  onStreamSelected($event: any): void {
    this.feedStream = $event[0]?.feedStream ?? null;
    this.disableStreamDesignSelection = false;
    if (this.feedStream?.toLowerCase() == 'blog') {
      this.selectedStreamDesign = StreamDesignType.Blog;
      this.disableStreamDesignSelection = true;
    } else if ($event?.length && $event[0]?.feedStreamDesign) {
      this.selectedStreamDesign = $event[0].feedStreamDesign;
      this.disableStreamDesignSelection = true;
    }
  }

  newStreamAdded() {
    if (this.action == 'update') {
      this.selectedStreamDesign = this.customTab?.PublicProperties?.feedStreamDesign || StreamDesignType.Feed
    }
  }

  onAllowOptionsChanged(options: { likes: boolean; comments: boolean; announcer: boolean }): void {
    // Handle the allow options change
    // You can store these values in your form or component state as needed
    console.log('Allow options changed:', options);
    this.form.controls['allowFeedOptions'].setValue(options);
  }

  onColorClick(val: string) {

    this.isCustomColor = SlideBg.isHexCodeNotInColors(val);
    if (this.isCustomColor) {
      this.customColor.setValue(val);
    }
    this.activeSlideBg = val;
    this.form.controls['backgroundColor'].setValue(val);

  }

  onCreateClick(): void {
    if (this.utilityType === TabUtilityType.FloatingTab) {
      if (this.floatingTabLimitReached) {
        this.alertService.error(this.translateService.instant('TabCustomizationPage.floatingLimitExceed'), { timeout: 3000 });
        return;
      }
    }

    if (this.form.controls['subtype']?.value == SubTypeEnum.NAVIGATION_TAB) {
      this.createReferenceTab();
    } else {
      this.createTab();
    }
  }

  createTab() {
    if (this.form.valid) {
      const viewOn = this.viewOnData.filter(tab => tab.active)
        .map(tab => tab.name)
        .join(',');
      const { icon, title, metaTitle, metaDescription, subtype, url,
        bannerHeading, bannerSubHeading, bannerButtonLabel,
        bannerButtonLink, urlName, backgroundColor, allowFeedOptions } = this.form.getRawValue();
      console.log('allowFeedOptions', allowFeedOptions);
      // return;
      const data = {
        icon,
        title,
        subtype: this.selectedSubtype,
        viewOn,
        groupSettingsAddonData: this.groupSettingsAddonData,
        url,
        productId: this.selectedItemIds,
        productName: this.selectedItemNames,
        slug: this.slug,
        visibleBy: this.visibleByComponent.generateVisibleBy(this.visibleByComponent.visibility),
        hiddenFrom: this.visibleByComponent.generateVisibleBy(this.visibleByComponent.hiddenFrom),
        metaTitle,
        metaDescription,
        feedStream: this.feedStream,
        feedStreamDesign: this.selectedSubtype == SubTypeEnum.FEEDS ? this.selectedStreamDesign : null,
        feedStreamLinkDesign: this.selectedStreamDesign == StreamDesignType.Links ? this.selectedDesign : null,
        urlName,
        dividers: this.selectedSubtype === SubTypeEnum.REQUESTS
          ? this.espDividers?.value?.join(',') ?? ''
          : this.selectedSubtype === SubTypeEnum.ACTIVITIES
            ? this.activitiesDivders?.value?.join(',') ?? ''
            : this.selectedSubtype === SubTypeEnum.SCORE_CARD
              ? this.scorecardDivders?.value?.join(',') ?? ''
              : '',
        isHighlightTab: this.highlightTab.value,
        backgroundColor,
        tabLayout: this.tabLayout,
        tabDescription: this.tabDescription,
        bannerData: {
          heading: bannerHeading,
          subHeading: bannerSubHeading,
          active: this.isBannerActive ? '1' : '0',
          backgroundImage: this.bannerImage,
          action: {
            label: bannerButtonLabel,
            link: bannerButtonLink
          }
        },
        allowFeedOptions
      }

      if (this.selectedDesignPageData?.url) {
        data.url = this.selectedDesignPageData.url;
      }

      if (this.isHomePage) {
        data['isLandingPageTab'] = 1;
      }

      this.emitNewTab.emit(data);
    }
  }

  createReferenceTab() {
    const { subtype } = this.form.getRawValue();
    const data = {
      subtype,
      viewOn: this.viewOnData.filter(tab => tab.active)
        .map(tab => tab.name)
        .join(','),
      refTab: this.selectedTabForFooter
    }
    this.emitNewTab.emit(data);
  }

  updateReferenceTab() {
    this.customTab.PublicProperties.refTab = this.form?.controls['footerTabCtrl']?.value ?? this.selectedTabForFooter;
    this.customTab.PublicProperties.viewOn = this.viewOnData.filter(tab => tab.active)
      .map(tab => tab.name)
      .join(','),
      this.emitFormValue.emit({
        customTab: Object.assign({}, this.customTab),
        groupLanguages: this.groupSettingsAddonData
      })
  }

  tabAvailabilityForFooter(tab) {
    if (this.action == 'create') {
      return !this.footerTabs?.some(tabs => tabs?.refTab == tab?.key);
    }
    else {
      if (tab?.key == this.customTab?.PublicProperties?.refTab) {
        return true;
      } else {
        return !this.footerTabs.some(tabs => tabs?.refTab == tab?.key)
      }
    }
  }

  onUpdateClick(): void {
    if (this.form.controls['subtype']?.value == SubTypeEnum.NAVIGATION_TAB) {
      this.updateReferenceTab();
    } else {
      if (this.form.valid) {
        const viewOnData = this.viewOnData.filter(tab => tab.active)
          .map(tab => tab.name)
          .join(',');

        const {
          icon: updatedIcon,
          title: updatedTitle,
          metaTitle: updatedMetaTitle,
          metaDescription: updatedMetaDescription,
          feedStream: updatedFeedStream,
          url,
          urlName: updatedUrlName,
          backgroundColor: updatedBackgroundColor,
          bannerHeading: updatedBannerHeading,
          bannerSubHeading: updatedBannerSubHeading,
          bannerButtonLabel: updatedBannerButtonLabel,
          bannerButtonLink: updatedBannerButtonLink,
          startDate: updatedStartDate,
          endDate: updatedEndDate,
          allowFeedOptions: updatedAllowOptions
        } = this.form.getRawValue();

        const startOfDay = updatedStartDate ? moment(updatedStartDate)
          .startOf('day').toISOString()
          // .format("YYYY-MM-DDTHH:mm:ss") 
          : '';

        const endOfDay = updatedEndDate ? moment(updatedEndDate)
          .endOf('day').toISOString()
          // .format("YYYY-MM-DDTHH:mm:ss")
          : '';

        if (this.tabType === TabTypeEnum.CustomTab) {
          const {
            icon,
            name,
            title,
            viewOn,
            customTabId,
            weblink,
            iFrameURL,
            visibleBy,
            hiddenFrom,
            metaTitle,
            metaDescription,
            feedStream,
            bannerData,
            urlName,
            isHighlightTab,
            tabLayout,
            tabDescription,
            backgroundColor,
            allowFeedOptions,
            ...props
          } = this.customTab.PublicProperties;
          this.customTab.PublicProperties = {
            icon: updatedIcon,
            name: updatedTitle,
            title: updatedTitle,
            viewOn: viewOnData,
            metaTitle: updatedMetaTitle,
            metaDescription: updatedMetaDescription,
            feedStream: updatedFeedStream,
            visibleBy: this.visibleByComponent.generateVisibleBy(this.visibleByComponent.visibility),
            hiddenFrom: this.visibleByComponent.generateVisibleBy(this.visibleByComponent.hiddenFrom),
            urlName: updatedUrlName,
            isHighlightTab: this.highlightTab.value,
            backgroundColor: updatedBackgroundColor,
            allowFeedOptions: updatedAllowOptions,
            bannerData: {
              heading: updatedBannerHeading,
              subHeading: updatedBannerSubHeading,
              active: this.isBannerActive ? '1' : '0',
              backgroundImage: this.bannerImage,
              action: {
                label: updatedBannerButtonLabel,
                link: updatedBannerButtonLink
              },
              startDate: startOfDay,
              endDate: endOfDay
            },
            ...props
          }
          if (this.customTab?.PublicProperties?.subtype == SubTypeEnum.IFRAME) {
            this.customTab.PublicProperties.iFrameURL = url;
          } else if (this.customTab?.PublicProperties?.subtype == SubTypeEnum.WEB_LINK) {
            this.customTab.PublicProperties.weblink = url;
          } else if ([SubTypeEnum.TOPIC, SubTypeEnum.LIBRARY, SubTypeEnum.REQUEST, SubTypeEnum.RequestCatalog, SubTypeEnum.DASHBOARD, SubTypeEnum.TILDA].includes(this.customTab?.PublicProperties?.subtype)) {
            this.customTab.PublicProperties.productId = this.selectedItemIds;
            this.customTab.PublicProperties.productName = this.selectedItemNames;
            this.customTab.PublicProperties.slug = this.slug;
          } else if ([SubTypeEnum.FEEDS].includes(this.customTab?.PublicProperties?.subtype)) {
            this.customTab.PublicProperties.feedStream = this.feedStream;
            this.customTab.PublicProperties.feedStreamDesign = this.selectedSubtype == SubTypeEnum.FEEDS ? this.selectedStreamDesign : null;
            this.customTab.PublicProperties.feedStreamLinkDesign = this.selectedStreamDesign === StreamDesignType.Links ? this.selectedDesign : null;
          } else if ([SubTypeEnum.NAV_GROUP].includes(this.customTab?.PublicProperties?.subtype)) {
            this.customTab.PublicProperties.tabLayout = this.tabLayout;
            this.customTab.PublicProperties.tabDescription = this.tabDescription;
          } else if ([SubTypeEnum.REQUESTS].includes(this.customTab?.PublicProperties?.subtype)) {
            this.customTab.PublicProperties.dividers = this.espDividers?.value?.join(',') ?? '';
            this.customTab.PublicProperties.productId = this.selectedItemIds;
            this.customTab.PublicProperties.productName = this.selectedItemNames;
          } else if ([SubTypeEnum.ACTIVITIES].includes(this.customTab?.PublicProperties?.subtype)) {
            this.customTab.PublicProperties.dividers = this.activitiesDivders?.value?.join(',') ?? '';
          } else if ([SubTypeEnum.SCORE_CARD].includes(this.customTab?.PublicProperties?.subtype)) {
            this.customTab.PublicProperties.dividers = this.scorecardDivders?.value?.join(',') ?? '';
          }
          if (this.customTab?.PublicProperties?.subtype == SubTypeEnum.TILDA) {
            this.customTab.PublicProperties.iFrameURL = this.selectedDesignPageData?.url;
          }

          this.emitFormValue.emit({
            customTab: Object.assign({}, this.customTab),
            groupLanguages: this.groupSettingsAddonData
          })
        }
        if (this.tabType === TabTypeEnum.Tab) {

          const { icon, name, viewOn, backgroundColor, isHighlightTab, visibleBy, hiddenFrom, metaTitle, metaDescription, bannerData, allowFeedOptions, ...props } = this.tab;

          this.tab = {
            icon: updatedIcon,
            name: updatedTitle,
            metaTitle: updatedMetaTitle,
            metaDescription: updatedMetaDescription,
            viewOn: viewOnData,
            isHighlightTab: this.highlightTab.value,
            backgroundColor: updatedBackgroundColor,
            bannerData: {
              heading: updatedBannerHeading,
              subHeading: updatedBannerSubHeading,
              active: this.isBannerActive ? '1' : '0',
              backgroundImage: this.bannerImage,
              action: {
                label: updatedBannerButtonLabel,
                link: updatedBannerButtonLink
              },
              startDate: startOfDay,
              endDate: endOfDay,
            },
            allowFeedOptions: updatedAllowOptions,
            ...props
          }
          console.log('@espdividers', this.espDividers)
          if ([TabKeyEnum.Requests, TabKeyEnum.EspRecords, TabKeyEnum.EspSurveys].includes(this.tab?.key as TabKeyEnum)) {
            this.tab.productId = this.selectedItemIds;
            this.tab.productName = this.selectedItemNames;
            this.tab.dividers = Array.isArray(this.espDividers?.value) ? this.espDividers.value.join(',') : '';
          }

          if (this.tab.key == TabKeyEnum.Activities) {
            this.tab.dividers = this.activitiesDivders?.value?.join(',') ?? '';
          }

          if (this.tab.key == TabKeyEnum.ScoreCard) {
            this.tab.dividers = this.scorecardDivders?.value?.join(',') ?? '';
          }

          if (this.tab.key == TabKeyEnum.Requests || this.tab.key == TabKeyEnum.Library) {
            const addon = this.addon;
            const addonDto = {
              PublicProperties: {
                ...addon.PublicProperties,
                subgroupsAccessList: this.visibleByComponent.generateVisibleBy(this.visibleByComponent.visibility),
                organziationId: this.orgId,
              },
              PrivateConfiguration: addon.Configuration,
              AccessToken: addon.AccessToken,
              RefreshToken: addon.Configuration.refresh_token,
              BaseUrl: addon.BaseUrl
            }
            this.tab.hiddenFrom = this.visibleByComponent.generateVisibleBy(this.visibleByComponent.hiddenFrom);
            this.emitFormValue.emit({
              tab: Object.assign({}, this.tab),
              addon: Object.assign({}, addonDto),
              groupLanguages: this.groupSettingsAddonData
            })
          } else {
            if (this.tab.key == TabKeyEnum.SocialMedia) {
              this.tab.groupId = this.selectedItemIds;
            }
            this.tab.visibleBy = this.visibleByComponent.generateVisibleBy(this.visibleByComponent.visibility);
            this.tab.hiddenFrom = this.visibleByComponent.generateVisibleBy(this.visibleByComponent.hiddenFrom);
            this.emitFormValue.emit({
              tab: Object.assign({}, this.tab),
              groupLanguages: this.groupSettingsAddonData
            })
          }

        }
        if (this.tab?.key === 'CustomersService' && this.tab?.viewOn == '') {
          let roomDiv = this.document?.getElementById("guest-room-iframe");
          roomDiv.style.display = 'none';
        }
        else if (this.tab?.key === 'CustomersService' && this.tab?.viewOn != '') {
          let roomDiv = this.document?.getElementById("guest-room-iframe");
          roomDiv.style.display = 'block';
        }
      }
    }
  }

  setSelectedBIType() {
    if (this.bannerImage == '') {
      this.selectedBIType = BannerImageEnum.None;
    } else if (this.bannerImage == 'White') {
      this.selectedBIType = BannerImageEnum.White;
    } else {
      this.selectedBIType = BannerImageEnum.Select_Image;
    }
  }

  setSelectedDesignPage() {
    if (this.action !== 'create' && this.customTab && this.customTab?.PublicProperties?.subtype == SubTypeEnum.TILDA) {
      this.selectedDesignPage = this.customTab?.PublicProperties?.productName;
    } else {
      this.selectedDesignPage = ''
    }
  }

  onBITypeSelected(event) {
    this.selectedBIType = event.value;
    if (this.selectedBIType == BannerImageEnum.White) {
      this.bannerImage = 'White';
    } else {
      this.bannerImage = '';
    }
  }

  onStreamDesignSelected(event) {
    if (event.value == 'links') {
      this.selectedStreamDesign = event.value;
      this.selectedDesign = DesignType.Cards;
    } else {
      this.selectedStreamDesign = event.value;
    }

  }

  onDesignSelected(event) {
    this.selectedDesign = event.value;
  }

  openFileExplorer() {
    this.document.getElementById("fileInput")?.click();
  }

  onImageSelected(file: FileItem) {
    const formData = new FormData();
    formData.append("file", file.FileData);
    this.fileService
      .uploadFile(formData).
      subscribe(
        (image) => {
          this.bannerImage = image.url;
        }, err => {
        }
      )
  }

  onImageRemoved() {
    this.bannerImage = '';
  }

  changeIcon(id: number): void {
    this.selectedTabIcon = id
    this.form.patchValue({ 'icon': this.selectedTabIcon })
  }

  changeView(idx: number): void {
    this.viewOnChanges = true;
    this.viewOnData[idx].active = !this.viewOnData[idx].active
  }
  changeWebMenu(event: MatSelectChange) {
    this.tab.webMenu = event.value;
  }

  onTabLayoutSelected($event: MatSelectChange): void {

    if (this.hasSubtype5 && this.orignalLayout === 'navigation' && $event.value === 'innertab') {
      this.alertService.error(
        !this.isArabic ? 'Please remove web link tabs to change tab group view.' : 'الرجاء إزالة  الروابط التبويبية لتغيير عرض المجموعة '
      );
      // Reset the dropdown to the original value if the condition is met
      this.cdr.detectChanges();
      this.tabLayout = this.orignalLayout;
    } else if (this.orignalLayout === 'navigation' && $event.value === 'innertab' && this.isNested) {
      this.alertService.error(
        !this.isArabic ? 'Please remove Tab Groups to change tab group view.' : 'الرجاء إزالة  الروابط التبويبية لتغيير عرض المجموعة '
      );
      this.cdr.detectChanges();
      this.tabLayout = this.orignalLayout;
    } else {
      this.tabLayout = $event.value;
    }
  }

  onSubtypeSelected($event: MatSelectChange) {
    this.emitSubtypeSelect.emit(+$event.value);
    this.selectedSubtype = $event.value;
    this.handleUrlCtrl(this.selectedSubtype);
    this.ctUrlNameCtrl()
    if (this.groupsVisibility?.length) {
      this.groupsVisibility[0].title = this.visibleByComponent.getOrganizationTitle();
    }
    this.selectedItemIds = '';
    this.selectedItemNames = '';
    this.slug = '';
    this.feedStream = '';
    this.setValuePlaceholder(this.selectedSubtype);

    if (this.isHomePage) {
      this.groupSettingsAddonData.forEach(el => {
        if (this.selectedSubtype !== this.subtype.IFRAME) {
          el.url = undefined;
        }
        if (this.selectedSubtype !== this.subtype.TOPIC) {
          el.topic = undefined;
        }
      });
    }
    this.isMetaDataEnable();
  }


  isMetaDataEnable() {
    this.enableMetaData = !(this.selectedSubtype == SubTypeEnum.NAV_GROUP || this.selectedSubtype == SubTypeEnum.WEB_LINK || this.tab?.key == TabKeyEnum.Language || this.tab?.key == TabKeyEnum.Search || this.selectedSubtype == SubTypeEnum.REQUESTS || this.selectedSubtype == SubTypeEnum.ACTIVITIES || this.selectedSubtype == SubTypeEnum.SCORE_CARD)
  }

  handleUrlCtrl(subType: SubTypeEnum, properties?: PublicProperties) {
    if (subType == SubTypeEnum.IFRAME || subType == SubTypeEnum.WEB_LINK) {
      // Web Link also accepts mailto:, an IFrame needs a real URL
      const validators = [Validators.required, subType == SubTypeEnum.WEB_LINK ? ValidateWeblink : RxwebValidators.url()];
      if (!this.form.get('url')) {
        this.form.addControl('url', new UntypedFormControl((properties?.iFrameURL ?? properties?.weblink) ?? '', validators))
      } else {
        this.form.get('url').setValidators(validators);
        this.form.get('url').updateValueAndValidity();
      }
    } else {
      if (this.form.get('url')) {
        this.form.removeControl('url')
      }
    }

  }

  ctUrlNameCtrl(properties?: PublicProperties) {
    const filterSubTypes = [SubTypeEnum.WEB_LINK, SubTypeEnum.NAVIGATION_TAB]
    if (!filterSubTypes.includes(this.selectedSubtype) && this.customTab?.PublicProperties?.isDefaultTab != 1
      && !this.isHomePage) {
      if (!this.form.get('urlName')) {
        this.form.addControl('urlName', new UntypedFormControl({
          value: properties?.urlName ?? '',
          disabled: (this.action == 'update' && this.customTab?.PublicProperties?.urlName),

        },
          [Validators.required, Validators.pattern('[a-z0-9_-]*'), this.uniqueUrlNameValidator]))
        if (!properties?.urlName && this.action !== 'update') {
          this.setUpUrlName();
        }
      }
    } else {
      if (this.form.get('urlName')) {
        this.form.removeControl('urlName')
      }
    }
  }

  // accessList: any[] = [];
  openAccessListDialog(groupVisibility: any) {
    const dialogConfig: MatDialogConfig = {
      autoFocus: false,
      data: {
        selectedGroups: groupVisibility.selectedGroups,
      }
    };

    this.subs.sink = this.dialog.open(AccessListDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((selectedGroups: string[]) => {
        if (!selectedGroups) { return; }
        if (!selectedGroups.length && (this.tab?.key == TabKeyEnum.Library || this.tab?.key == TabKeyEnum.Requests)) {
          selectedGroups.push('0');
        }
        groupVisibility.selectedGroups = selectedGroups;
      });
  }
  initTabAccessList() {
    let accessList = [];
    let visibleBy;
    if (this.customTab) {
      visibleBy = this.customTab?.PublicProperties?.visibleBy;
    }
    else if (this.tab) {
      if (!this.tab?.visibleBy && this.tabtypehome === 'home') {
        const hTab = this.tabOrderAddon?.PublicProperties?.jsonData?.home?.find(tab => tab.key === this.tab.key);
        this.tab['visibleBy'] = hTab?.visibleBy || [];
        this.tab['hiddenFrom'] = hTab?.hiddenFrom || [];
      }
      visibleBy = this.tab?.visibleBy;
    }
    accessList = visibleBy?.map(v => Object.keys(v)[0]) ?? [];
    if (!visibleBy) {
      accessList.push(this.group.Idenedi);
      if (this.tab || this.customTab) {
        accessList.push('anonymous');
      }
    }

    if (this.tab?.key == TabKeyEnum.Requests || this.tab?.key == TabKeyEnum.Library) {
      if (this.tab?.key == TabKeyEnum.Library && this.technadoptAddon) {
        this.addon = JSON.parse(JSON.stringify(this.technadoptAddon));
        this.subs.sink = this.connectAppService.fetchTechnadoptOrganizations(this.getTechnadoptAccessList(this.addon)).subscribe(orgs => {
          const subgroupsAccessList = this.addon.PublicProperties.subgroupsAccessList ?? [];

          // const availableAcessGroups = subgroupsAccessList.filter(sgAl => {
          //   const group = Object.keys(sgAl)[0];
          //   return sgAl[group].split(',').some(acl => allOrgIds.includes(acl));
          // })

          const addonOrgs = [...new Set(subgroupsAccessList.reduce((accessList, acl) => {
            accessList = accessList.concat(Object.keys(acl).reduce((a, key) => {
              const orgs = acl[key].split(',');
              a = a.concat(orgs);
              return a;
            }, []).flat())
            return accessList;
          }, []))];
          this.groupsVisibility = addonOrgs.map(orgId => {
            const selectedGroups = subgroupsAccessList.filter(sgAl => {
              const group = Object.keys(sgAl)[0];
              return sgAl[group].split(',').includes(orgId);
            }).map(s => {
              return Object.keys(s)[0];
            })
            return {
              orgId: orgId,
              title: (orgId.toLowerCase() == '') ? '' : (orgs.find(o => o.AccessListId == orgId)?.AccessListName),
              selectedGroups: selectedGroups
            }
          })
        })
      }
      if (this.tab?.key == TabKeyEnum.Requests && this.espAddon) {
        this.addon = JSON.parse(JSON.stringify(this.espAddon));
        this.groupsVisibility = [];
        const selectedGroups = this.subGroups.filter(sg => accessList.includes(sg.Idenedi));
        const desc = selectedGroups.length ? selectedGroups.map(sg => sg.Profile.FirstName).join(', ') : 'None';
        let orgId = this.addon.OrganziationId ?? Object.values(this.addon?.PublicProperties?.subgroupsAccessList[0])[0]
        const groupVisibility = {
          orgId: this.addon.OrganziationId ?? orgId,
          title: this.addon.PublicProperties.organizationName,
          description: desc,
          selectedGroups: selectedGroups.map(sg => sg.Idenedi)

        }
        this.groupsVisibility.push(groupVisibility);
      }

    }
    else {
      this.groupsVisibility = []
      const selectedGroups = this.subGroups.filter(sg => accessList.includes(sg.Idenedi));
      const desc = selectedGroups.length ? selectedGroups.map(sg => sg.Profile.FirstName).join(', ') : 'None'
      const groupVisibility = {
        orgId: '0',
        title: this.getOrganizationTitle(),
        description: desc,
        selectedGroups: selectedGroups.map(sg => sg.Idenedi)

      }

      this.groupsVisibility.push(groupVisibility)
    }
  }

  private getTechnadoptAccessList(addon: Addon): any {
    let visibleBy = addon?.PublicProperties?.subgroupsAccessList ? JSON.parse(JSON.stringify(addon?.PublicProperties?.subgroupsAccessList)) : [];
    if (addon?.PublicProperties?.organziationId && this.authService.idenediGroupId) {
      let mainGroup = {};
      mainGroup[this.authService.idenediGroupId] = addon?.PublicProperties?.organziationId;
      visibleBy.push(mainGroup);
    }
    return [...new Set(visibleBy.map(acl => Object.values(acl)[0]).join().split(','))].join()
  }

  getOrganizationTitle() {
    let text = '';
    if (this.isHomePage) {
      text = 'Home'
    } else if (this.customTab) {
      switch (this.customTab?.PublicProperties.subtype) {
        case -1:
          text = 'Home';
          break;
        case SubTypeEnum.TOPIC:
          text = 'Topic';
          break;
        case SubTypeEnum.LIBRARY:
          text = 'Library';
          break;
        case SubTypeEnum.REQUEST:
          text = 'Request';
          break;
        case SubTypeEnum.RequestCatalog:
          text = 'Request Catalog';
          break;
        case SubTypeEnum.IFRAME:
          text = this.form.value.url || 'IFrame';
          break;
        case SubTypeEnum.WEB_LINK:
          text = this.form.value.url || 'Web Link';
          break;
        case SubTypeEnum.TILDA:
          text = 'Design Pages';
          break;
        default:
          text = this.customTab?.PublicProperties?.name;
          break;
      }
    } else if (this.tab) {
      switch (this.tab.key) {
        case TabKeyEnum.Activities:
          text = 'Simple Strata';
          break;
        case TabKeyEnum.Blog:
          text = 'Blog';
          break;
        case TabKeyEnum.Feed:
          text = 'iDenedi Announcements';
          break;
        case TabKeyEnum.ScoreCard:
          text = 'Score Card';
          break;
        case TabKeyEnum.Library:
          text = 'Technadopt';
          break;
        case TabKeyEnum.Requests:
          text = 'ESP Requests';
          break;
        case TabKeyEnum.EspRecords:
          text = 'ESP Records';
          break;
        case TabKeyEnum.EspSurveys:
          text = 'ESP Records';
          break;
        case TabKeyEnum.Activities:
          text = 'Simple Strata';
          break;
        case TabKeyEnum.EngagementPro:
          text = 'Projects';
          break;
        case TabKeyEnum.Calendar:
          text = 'Calendar';
          break;
        case TabKeyEnum.Members:
          text = 'iDenedi Members';
          break;
        case TabKeyEnum.ContactCard:
          text = 'iDenedi Contact Card';
          break;
        case TabKeyEnum.Intajy:
          text = 'Intajy';
          break;
        case TabKeyEnum.Chat:
          text = 'Chat';
          break;
        default:
          text = this.tab.name || this.tab.data.name;
          break;
      }
    } else {
      switch (this.form.value.subtype) {
        case -1:
          text = 'Home';
          break;
        case SubTypeEnum.TOPIC:
          text = 'Topic';
          break;
        case SubTypeEnum.LIBRARY:
          text = 'Library';
          break;
        case SubTypeEnum.REQUEST:
          text = 'Request';
          break;
        case SubTypeEnum.RequestCatalog:
          text = 'Request Catalog';
          break;
        case SubTypeEnum.IFRAME:
          text = this.form.value.url || 'IFrame';
          break;
        case SubTypeEnum.WEB_LINK:
          text = this.form.value.url || 'Web Link';
          break;
        case SubTypeEnum.NAV_GROUP:
          text = 'Tab Group';
          break;
        case SubTypeEnum.FEEDS:
          text = 'Feeds';
          break;
        case SubTypeEnum.TILDA:
          text = 'Design Pages';
          break;
        case SubTypeEnum.SCORE_CARD:
          text = 'Score Card';
          break;
        case SubTypeEnum.ACTIVITIES:
          text = 'Activties';
          break;
        case SubTypeEnum.REQUESTS:
          text = 'Requests';
          break;
        default:
          text = this.customTab?.PublicProperties?.name;
          break;
      }
    }
    return text;
  }

  getOrgDescription(groupVisibility: any) {
    const selectedGroups = this.subGroups.filter(sg => groupVisibility.selectedGroups.includes(sg.Idenedi));
    const desc = selectedGroups.length ? selectedGroups.map(sg => sg.Profile.FirstName).join(', ') : 'None';
    return desc;
  }
  private _loadSubGroups() {
    this.loadingService.loadingOn();
    this.subs.sink = this.groupsService
      .getGroupDetailsPublic(this.authService.idenediGroupId)
      .pipe(concatMap(group => {
        this.group = group;
        return this.groupsService
          .fetchSubGroups(this.authService.idenediGroupId)
      }), finalize(() => { this.loadingService.loadingOff(); })).subscribe(subGroups => {
        const anonymousGroup = new GroupDetail(this.group);
        anonymousGroup.Idenedi = 'anonymous',
          anonymousGroup.Profile.FirstName = "Non Members";
        const makeAdmin = new GroupDetail(this.group);
        makeAdmin.Idenedi = 'admin',
          makeAdmin.Profile.FirstName = "Admins";
        this.subGroups = [anonymousGroup, makeAdmin, this.group, ...subGroups];
        if (this.tab?.key == TabKeyEnum.SocialMedia) {
          this.loadSocialMediaSelectedValue();
        }

        this.initTabAccessList();
      })
  }


  generateVisibleBy(array: Array<any>) {
    let visibleBy = [];
    const orgIds = []
    let allGroups = []
    array.forEach(v => {
      visibleBy = visibleBy.concat(v.selectedGroups.map(g => { return { [g]: v.orgId } }))
      orgIds.push(v.orgId);
      allGroups = allGroups.concat(v.selectedGroups)
    })


    if (this.tab?.key == TabKeyEnum.Requests || this.tab?.key == TabKeyEnum.Library) {
      const allowMainGroup = visibleBy.map(v => Object.keys(v)[0]).includes(this.authService.idenediGroupId);
      this.orgId = allowMainGroup ? orgIds.join(',') : ''

      allGroups = [...new Set(allGroups)];
      visibleBy = allGroups.map(g => {

        const val = visibleBy.filter(vb => !!vb[g]).map(vb => Object.values(vb)[0]).join(',');
        return { [g]: val }
      })
      const mainGroup = visibleBy.find(v => Object.keys(v).includes(this.authService.idenediGroupId));
      if (mainGroup) {
        this.orgId = mainGroup[this.authService.idenediGroupId];
      }
      visibleBy = visibleBy.filter(v => !Object.keys(v).includes(this.authService.idenediGroupId));

    }
    return visibleBy;
  }
  loadSocialMediaSelectedValue() {
    if (this.tab && this.group) {
      this.selectedItemIds = this.tab?.groupId ?? this.group.Idenedi;
      this.selectedItemNames = this.subGroups.find(sg => sg.Idenedi == this.selectedItemIds)?.Profile?.FirstName ?? this.group.Profile.FirstName;
    }
  }
  openSelectValueDialog(event) {
    const subtype = this.form.getRawValue()?.subtype;
    const isEspCustomTab = [SubTypeEnum.REQUEST, SubTypeEnum.REQUESTS, SubTypeEnum.RequestCatalog].includes(subtype);
    const isEspTab = [TabKeyEnum.Requests, TabKeyEnum.EspRecords, TabKeyEnum.EspSurveys].includes(this.tab?.key as TabKeyEnum);
    let request$: Observable<any>;
    if (isEspCustomTab || isEspTab) {
      if (subtype == SubTypeEnum.REQUEST || SubTypeEnum.REQUESTS) {
        request$ = this.connectAppService.getEspRequests();
      } else if (subtype == SubTypeEnum.RequestCatalog) {
        request$ = this.connectAppService.getEspServices();
      }
      else if (isEspTab) {
        request$ = this.connectAppService.getEspServices(this.tab?.key == TabKeyEnum.EspRecords || this.tab?.key == TabKeyEnum.EspSurveys);
      }

      if (request$) {
        this.subs.sink = this.dialog.open(CustomTabValueDialogComponent,
          {
            autoFocus: false,
            data: {
              type: subtype ?? this.tab.key,
              selectedItems: this.selectedItemIds,
              request: request$,
            }
          }).afterClosed().subscribe((items: any[]) => {
            if (items) {
              this.setSelectedItems(items);
            }
          })
      }
    } else if (subtype == SubTypeEnum.TOPIC) {
      let routeData;
      this.route.data.subscribe(d => {
        routeData = d?.technadoptData;
      })
      this.subs.sink = this.dialog.open(TopicSearchDialogComponent, {
        autoFocus: false,
        direction: this.langService.currentLanguage.isRtl ? 'rtl' : 'ltr',
        width: "37.5rem",
        panelClass: 'xcdr-default-dialog',
        data: {
          accessList: routeData?.userAccessListIds,
          selectedItemId: this.selectedItemIds,
          isRelatedTopicCall: false,
        }
      }).afterClosed().subscribe((item) => {
        if (item) {
          // this.form.controls['urlName']?.setValue(item['slug']);
          this.setSelectedItems([item]);
        }
      })
    } else if (subtype == SubTypeEnum.LIBRARY) {
      let routeData;
      this.route.data.subscribe(d => {
        routeData = d?.technadoptData;
      })
      this.subs.sink = this.dialog.open(TopictypeSearchDialogComponent, {
        autoFocus: false,
        direction: this.langService.currentLanguage.isRtl ? 'rtl' : 'ltr',
        width: "37.5rem",
        panelClass: 'xcdr-default-dialog',
        data: {
          accessList: routeData?.userAccessListIds,
          selectedItemId: this.selectedItemIds,
        }
      }).afterClosed().subscribe((item) => {
        if (item) {
          // this.form.controls['urlName']?.setValue(item['slug']);
          this.setSelectedItems([item]);
        }
      })
    }
    else if (subtype == SubTypeEnum.DASHBOARD) {
      this.subs.sink = this.dialog.open(CustomTabValueDialogComponent, {
        autoFocus: false,
        data: {
          type: subtype,
          selectedItems: this.selectedItemIds,
        }
      }).afterClosed().subscribe((items: any[]) => {
        if (items) {
          this.setSelectedItems(items);
        }
      })
    }
    else if (subtype == SubTypeEnum.TILDA) {
      this.subs.sink = this.dialog.open(TildaProjectsDialogComponent, {
        autoFocus: false,
        direction: this.langService.currentLanguage.isRtl ? 'rtl' : 'ltr',
        width: "37.5rem",
        panelClass: 'xcdr-default-dialog',
        data: {
          tildaAddon: this.tildaAddon
        }
      }).afterClosed().subscribe((page) => {
        if (page) {
          this.savePage(page);
        }
      })
    }
    else if (this.tab?.key == TabKeyEnum.SocialMedia) {
      this.subs.sink = this.dialog.open(CustomTabValueDialogComponent, {
        autoFocus: false,
        data: {
          items: this.subGroups.filter(sg => sg.Idenedi != 'anonymous').map(sg => {
            return {
              id: sg.Idenedi,
              name: sg.Profile.FirstName
            }
          }),
          type: this.tab.key,
          selectedItems: this.selectedItemIds,
        }
      }).afterClosed().subscribe((items: any[]) => {
        if (items) {
          this.setSelectedItems(items);
        }
      })
    }

  }

  setTopicForLang(languageKey: string) {
    let routeData;
    this.route.data.subscribe(d => {
      routeData = d?.technadoptData;
    });
    const lang = this.groupSettingsAddonData.find(lad => lad.langKey == languageKey);
    this.subs.sink = this.dialog.open(TopicSearchDialogComponent, {
      autoFocus: false,
      direction: this.langService.currentLanguage.isRtl ? 'rtl' : 'ltr',
      width: "37.5rem",
      panelClass: 'xcdr-default-dialog',
      data: {
        accessList: routeData?.userAccessListIds,
        selectedItemId: lang?.topic?.id || '',
        isRelatedTopicCall: false,
      }
    }).afterClosed().subscribe((item) => {
      if (item && this.groupSettingsAddonData?.length) {
        this.groupSettingsAddonData.map(lo => {
          if (lo.langKey == languageKey) {
            lo.topic = item;
          }
          return lo;
        })
      }
    })
  }

  setLibraryForLang(languageKey: string) {
    let routeData;
    this.route.data.subscribe(d => {
      routeData = d?.technadoptData;
    });
    const lang = this.groupSettingsAddonData.find(lad => lad.langKey == languageKey);
    this.subs.sink = this.dialog.open(TopictypeSearchDialogComponent, {
      autoFocus: false,
      direction: this.langService.currentLanguage.isRtl ? 'rtl' : 'ltr',
      width: "37.5rem",
      panelClass: 'xcdr-default-dialog',
      data: {
        accessList: routeData?.userAccessListIds,
        selectedItemId: lang?.library?.id || '',
      }
    }).afterClosed().subscribe((item) => {
      if (item && this.groupSettingsAddonData?.length) {
        this.groupSettingsAddonData.map(lo => {
          if (lo.langKey == languageKey) {
            lo.library = item;
          }
          return lo;
        })
      }
    })
  }

  // Function to fetch the latest details of the topictype when updating
  fetchTopicTypeName(topicTypeId: string): Observable<string> {
    return this.route.data.pipe(
      switchMap(d => {
        const routeData = d?.technadoptData;
        return this.topicTypeService.getTopicTypes(routeData?.userAccessListIds?.toString());
      }),
      map(tts => {
        const topicType = tts.find(tt => tt.TopicTypeId === topicTypeId);
        if (topicType) {
          try {
            const nameObj = JSON.parse(topicType.TopicTypeName);
            return nameObj.en || nameObj.ar || topicType.TopicTypeName;
          } catch (error) {
            return topicType.TopicTypeName;
          }
        }
        return '';
      })
    );
  }

  private setSelectedItems(items: any[]) {
    if (items) {
      this.selectedItemIds = items.map(i => i.id).join(',');
      this.selectedItemNames = items.map(i => i.name).join(',');
      this.slug = items.map(i => i.slug).join(',');
    }
  }
  showCustomTabValueControl() {
    return [SubTypeEnum.TOPIC, SubTypeEnum.LIBRARY, SubTypeEnum.REQUEST, SubTypeEnum.RequestCatalog].includes(this.selectedSubtype);
  }

  allowRequestSelection: boolean = false;
  toggleRequestSelection($event) {
    this.allowRequestSelection = !this.allowRequestSelection;
    if (!this.allowRequestSelection) {
      this.selectedItemIds = '';
      this.selectedItemNames = '';
      this.slug = '';
    }
  }

  initTabsList() {
    this.loadingService.loadingOn();
    this.sharedService.initTabCustomizationList(false).pipe(
      switchMap(res => {
        this.footerTabs = res.tabs.filter((t) => t.key?.startsWith('footer'));
        this.allTabs = res.tabs.filter((t) => !t.key?.startsWith('footer'));
        const utilityIconTabsKeys = this.sharedService.getHeaderTabs().filter(t => t.utilityType == 'icon').map(t => t.key);
        const utilityTextTabsKeys = this.sharedService.getHeaderTabs().filter(t => t.utilityType == 'text').map(t => t.key);
        // const footerUtilitiesTabs = this.allTabs.filter(tab => tab.utilityType == 'footerUtilities')
        this.allTabs = this.allTabs.filter(tab => !utilityIconTabsKeys.includes(tab.key) && !utilityTextTabsKeys.includes(tab.key))
        this.floatingTabLimitReached = this.allTabs.filter(t => t.utilityType == 'floatingTab' && t.key !== TabKeyEnum.CustomersService).length === 5;
        return this.sharedService.filterTabsByConnectedApps(this.allTabs);
      }), finalize(() => {
        this.loadingService.loadingOff();
      })).subscribe(res => {
        this.allTabs = res;
        if (this.utilityType == 'footer' || this.utilityType == TabUtilityType.SocialFooterUtility) {
          this.allTabs = this.allTabs.filter(ts => ts?.data?.subtype != SubTypeEnum.NAV_GROUP);
        }
        if (this.action == 'update') {
          this.setTabForFooter();
        }
      })
  }

  onFooterTabSelected(event) {
    this.selectedTabForFooter = event.value;
  }

  setTabForFooter() {
    let footerTab;
    if (this.allTabs) {
      footerTab = this.allTabs.find(t => t?.key == this.customTab?.PublicProperties?.refTab)?.key;
      this.form.controls['footerTabCtrl'].setValue(footerTab);
    }
  }

  savePage(page) {
    this.loadingService.loadingOn();
    this.tildaService.savePage(page?.id,
      this.tildaAddon.Configuration.publickey,
      this.tildaAddon.Configuration.secretkey).pipe(finalize(() => {
        this.loadingService.loadingOff();
      })).subscribe(res => {
        this.selectedDesignPage = page?.title;
        this.selectedItemIds = page?.id;
        this.selectedItemNames = page?.title;
        this.selectedDesignPageData = {
          id: page?.id,
          name: page?.name,
        }
        this.selectedDesignPageData.url = res['str'] ?? '';
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    clearTimeout(this.typingTimer);

  }
}

